<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { DropdownPlacement } from '@/enums/DropdownPlacement.enum';
import CDropdown from '@/components/shared/CDropdown.vue';
import CButtonIcon from '@/components/shared/CButtonIcon.vue';
import { ButtonIconType } from '@/enums/ButtonIconType.enum';
import { ButtonIconColor } from '@/enums/ButtonIconColor.enum';

enum ComponentEvent {
	DOWNLOAD_IMAGE = 'downloadImage',
	DOWNLOAD_PDF = 'downloadPDF',
	DOWNLOAD_FILE = 'downloadFile',
}

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'MapDownloadDropdown',
	components: { CButtonIcon, CDropdown },
	props: {
		buttonIconType: {
			required: false,
			type: String as PropType<ButtonIconType>,
			default: () => ButtonIconType.RAISED,
		},
		buttonIconColor: {
			required: false,
			type: String as PropType<ButtonIconColor>,
			default: () => ButtonIconColor.BASIC,
		},
		hideAnimation: {
			required: false,
			type: Boolean,
			default: false,
		},
		placement: {
			required: false,
			type: String as PropType<DropdownPlacement>,
			default: () => DropdownPlacement.BOTTOM,
		},
		shadowRoot: {
			required: true,
			type: [ShadowRoot, null],
		},
	},
	setup(props, context) {
		return {
			context,
			faDownload,
			DropdownPlacement,
			ComponentEvent,
		};
	},
	data() {
		return {
			dropdownTriggerActive: false,
		};
	},
});
</script>

<template>
	<c-dropdown
		:placement="placement"
		:hide-animation="hideAnimation"
		:shadow-root="shadowRoot"
		@change-visibility="dropdownTriggerActive = $event"
	>
		<template #trigger="{ toggleVisibility }">
			<c-button-icon
				:type="buttonIconType"
				:color="buttonIconColor"
				:icon-name="faDownload.iconName"
				:is-active="dropdownTriggerActive"
				@click="toggleVisibility()"
			/>
		</template>
		<template #content="{ toggleVisibility }">
			<ul class="map-download-dropdown__list">
				<li
					@click="
						$emit(ComponentEvent.DOWNLOAD_IMAGE);
						toggleVisibility();
					"
				>
					{{ $t('options.download.image') }}
				</li>
				<li
					@click="
						$emit(ComponentEvent.DOWNLOAD_PDF);
						toggleVisibility();
					"
				>
					{{ $t('options.download.pdf') }}
				</li>
				<li
					@click="
						$emit(ComponentEvent.DOWNLOAD_FILE);
						toggleVisibility();
					"
				>
					{{ $t('options.download.file') }}
				</li>
			</ul>
		</template>
	</c-dropdown>
</template>

<style scoped lang="scss">
.map-download-dropdown__list {
	> li {
		min-width: 120px;
		cursor: pointer;
		padding: 6px 16px;

		&:hover {
			background-color: tokens.$color-gray-f5;
		}
	}
}
</style>
